<section class="shoe-banner" aria-label="Featured shoe animation banner">
  <div class="shoe-banner__inner">
    <div class="shoe-banner__copy">
      <h2 class="shoe-banner__title">Zodi.</h2>
    </div>

    <div class="shoe-banner__visual" aria-hidden="true">
      <div
        *ngIf="showIntroShoes"
        class="shoe-banner__asset shoe-banner__asset--side shoe-banner__asset--intro"
        [class.shoe-banner__asset--hiding]="isHidingIntroShoes"
      >
        <img class="shoe-banner__image shoe-banner__image--side" src="assets/images/sideShoe.png" alt="" />
      </div>
      <div
        *ngIf="showIntroShoes"
        class="shoe-banner__asset shoe-banner__asset--upright shoe-banner__asset--intro"
        [class.shoe-banner__asset--hiding]="isHidingIntroShoes"
      >
        <img class="shoe-banner__image shoe-banner__image--upright" src="assets/images/uprightShoe.png" alt="" />
      </div>
      <div *ngIf="showPairShoe" class="shoe-banner__asset shoe-banner__asset--pair">
        <img class="shoe-banner__image shoe-banner__image--pair" src="assets/images/shoePairWhite.png" alt="" />
      </div>
    </div>

    <div class="shoe-banner__cta">
      <button mat-raised-button color="primary" routerLink="/products">
        Shop Now
      </button>
    </div>
  </div>
</section>